angular.module('core')
  .directive('printSection', [
    'dblPrintService',
  function (
    dblPrintService
  ) {

    return {
        restrict: 'E',
        link: function($scope, $element, $attr) {
            var shouldSetWidth = $attr.shouldSetWidth === 'true';

            $element.on('click', function () {
                var elemToPrint = $('#' + $attr.printElementId);
                if (elemToPrint) {
                    dblPrintService.printElement(elemToPrint, $attr.showLogo, $attr.showBreadcrumbs, true, shouldSetWidth);
                }
            });
        }
    };
}]);
